var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jc-component__range"})
}
var staticRenderFns = []

export { render, staticRenderFns }